import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import boost from "highcharts/modules/boost";
import Exporting from "highcharts/modules/exporting";
import LoadingOverlay from "../Loaders/LoadingOverlay";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import { isEmpty } from "lodash";
import { Trans } from "react-i18next";

Exporting(Highcharts);
NoDataToDisplay(Highcharts);
boost(Highcharts);

const BasicBarChart = ({ cardTitle, measurementUnit, data, isLoading }) => {
    const [options, setOptions] = useState({});

    useEffect(() => {
        if (!isEmpty(data)) {
            setChartOptions();
        }
    }, [data]);

    const setChartOptions = () => {
        setOptions({
            chart: {
                type: "bar",
                zoomType: "x",
            },
            title: {
                text: "",
            },
            subtitle: {
                text: "",
            },
            xAxis: {
                categories: data?.categories || [],
                title: {
                    text: null,
                },
            },
            yAxis: {
                min: 0,
                title: {
                    text: `Total ${measurementUnit}`,
                    align: "high",
                },
                labels: {
                    overflow: "justify",
                },
            },
            tooltip: {
                valueSuffix: ` ${measurementUnit}`,
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                    },
                },
            },
            legend: {
                enabled: false,
            },
            credits: {
                enabled: false,
            },
            series: [
                {
                    colorByPoint: true,
                    name: "Count",
                    data: data?.data || [],
                },
            ],
        });
    };

    const renderChart = () => {
        if (!isEmpty(data?.data) && !isEmpty(options)) {
            return (
                <div className="relative bg-white mb-4">
                    <div className="min-h-full">
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={options}
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <div className="relative bg-white">
                    <p className="chart-placeholder">
                        <Trans i18nKey="noScansDisplayMessage">
                            Get started by creating scans through Scan App
                        </Trans>
                    </p>
                </div>
            );
        }
    };

    return (
        <>
            <LoadingOverlay active={isLoading}>
                <div className="flex flex-col mb-5">
                    <div className="relative flex flex-col min-w-0 break-words w-full mb-2 rounded card-container shadow">
                        <h3 className="card-title">{cardTitle}</h3>
                        <div className="px-4">
                            {/* Chart */}
                            {renderChart()}
                        </div>
                    </div>
                </div>
            </LoadingOverlay>
        </>
    );
};

export default BasicBarChart;
